import { useEffect } from 'react';
import Icon from 'components/shared/icon';

export const LoadingScreen = () => (
  <div
    style={{
      height: '80vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Icon type="loading" />
  </div>
);

const OauthRedirect = ({ locale }) => {
  useEffect(() => {
    window.location.replace(`/api/shopify/account/oauth-login/?locale=${locale}`);
  }, [locale]);

  return <LoadingScreen />;
};

export default OauthRedirect;
